import { render, staticRenderFns } from "./AddEditServiceItem.vue?vue&type=template&id=03102b92"
import script from "./AddEditServiceItem.vue?vue&type=script&lang=js"
export * from "./AddEditServiceItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports